import React from "react";
import { WhatsappLogo, Phone } from "@phosphor-icons/react";
import { WHATSAPP_URL, PHONE_TEL } from "@/lib/contact";

export default function FloatingContact() {
  return (
    <div className="fixed bottom-5 right-5 z-40 flex flex-col gap-3" data-testid="floating-contact">
      <a
        href={WHATSAPP_URL}
        target="_blank"
        rel="noreferrer"
        data-testid="whatsapp-fab"
        aria-label="WhatsApp"
        className="w-14 h-14 rounded-full bg-[#25D366] flex items-center justify-center shadow-[0_10px_30px_rgba(37,211,102,0.45)] hover:scale-105 transition-transform duration-200"
      >
        <WhatsappLogo size={28} weight="fill" color="#fff" />
      </a>
      <a
        href={`tel:${PHONE_TEL}`}
        data-testid="call-fab"
        aria-label="Call"
        className="w-14 h-14 rounded-full bg-[#EF5A1E] flex items-center justify-center shadow-[0_10px_30px_rgba(43,75,255,0.45)] hover:scale-105 transition-transform duration-200"
      >
        <Phone size={26} weight="fill" color="#fff" />
      </a>
    </div>
  );
}
